/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, it uses the American style without 'and' — 'one hundred one'. The British style with 'and' may be added later.`)
};

const es_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, utiliza el estilo americano sin 'and' — 'one hundred one'. El estilo británico con 'and' puede agregarse más adelante.`)
};

const de_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein, es wird der amerikanische Stil ohne 'and' verwendet — 'one hundred one'. Der britische Stil mit 'and' könnte später hinzugefügt werden.`)
};

const nl_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee, het gebruikt de Amerikaanse stijl zonder 'en' — 'one hundred one'. De Britse stijl met 'en' kan later worden toegevoegd.`)
};

const fr_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non, il utilise le style américain sans 'and' — 'one hundred one'. Le style britannique avec 'and' pourrait être ajouté plus tard.`)
};

const it_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, usa lo stile americano senza 'and' — 'one hundred one'. Lo stile britannico con 'and' potrebbe essere aggiunto in seguito.`)
};

const pt_br2_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, ele usa o estilo português padrão com "e" — "cento e um". Variações de outras regiões podem ser adicionadas mais tarde.`)
};

const pt_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, utiliza o estilo americano sem 'and' — 'one hundred one'. O estilo britânico com 'and' pode ser adicionado mais tarde.`)
};

const ja_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ、「and」なしのアメリカン・スタイルを使用しています。「one hundred one」です。「and」付きのイギリス・スタイルは後で追加される可能性があります。`)
};

const zh_nw_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会，它采用不带“and”的美式写法——即“one hundred one”。带“and”的英式写法可能会在以后添加。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_faq2_a", locale)
	if (locale === "en") return en_nw_faq2_a(inputs)
	if (locale === "es") return es_nw_faq2_a(inputs)
	if (locale === "de") return de_nw_faq2_a(inputs)
	if (locale === "nl") return nl_nw_faq2_a(inputs)
	if (locale === "fr") return fr_nw_faq2_a(inputs)
	if (locale === "it") return it_nw_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_nw_faq2_a(inputs)
	if (locale === "pt") return pt_nw_faq2_a(inputs)
	if (locale === "ja") return ja_nw_faq2_a(inputs)
	return zh_nw_faq2_a(inputs)
};